import React, { useEffect, useState } from "react";

export default function SavedCandidates() {
  const [candidates, setCandidates] = useState([]);
  const [notes, setNotes] = useState({});

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("shortlistedCandidates") || "[]");
    const savedNotes = JSON.parse(localStorage.getItem("candidateNotes") || "{}");

    setCandidates(saved);
    setNotes(savedNotes);
  }, []);

  const removeCandidate = (id) => {
    const updated = candidates.filter((c) => c.scan_id !== id);
    setCandidates(updated);
    localStorage.setItem("shortlistedCandidates", JSON.stringify(updated));
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Saved Candidates</h2>

      {candidates.length === 0 ? (
        <p>No shortlisted candidates</p>
      ) : (
        candidates.map((c, i) => (
          <div key={i} className="border p-4 rounded mb-3">
            <div className="flex justify-between">
              <div>
                <p className="font-bold">{c.filename}</p>
                <p className="text-sm">Score: {c.match_score}%</p>
              </div>

              <button
                onClick={() => removeCandidate(c.scan_id)}
                className="text-red-500"
              >
                Remove
              </button>
            </div>

            <p className="text-sm mt-2">
              <strong>Notes:</strong> {notes[c.scan_id] || "No notes"}
            </p>
          </div>
        ))
      )}
    </div>
  );
}